import { t } from 'i18n';
import React from 'react';
import {
  Card,
  styled,
  Button,
  // Tab,
  // Tabs,
  // ThemeProps,
  // TabProps,
} from '@teko/ui';
import { Loading } from '../../Loading';
import { Notification as Noti } from '@teko/notification';
import { AccountLayout } from '../../Layout/AccountLayout';
import { MiniNotificationItem } from '../organisms/MiniNotificationItem';
import { useRouter } from 'next/router';
import { EmptyState } from '@teko/ecommerce/mobile';
import { PageStatus, useNotification } from 'contexts';
// TODO: bug/UX4BUYER-2904
// interface StyledTabProps extends TabProps, ThemeProps {}
// const StyledTabs = styled(Tabs)`
//   border-radius: 8px;
//   .tab-header {
//     border-bottom: 1px solid #e0e0e0;
//   }
// `;
// const StyledTab = styled(Tab)<StyledTabProps>`
//   background-color: #fff;
//   padding: 0.5rem 1rem;
//   color: #848788;
//   z-index: 1;
//   h5 {
//     font-size: 0.875rem;
//   }
//   &:first-of-type {
//     border-top-left-radius: 8px;
//   }
//   &.active {
//     color: ${(props) => props.theme.brand.primary};
//     position: relative;
//     &:before {
//       position: absolute;
//       content: '';
//       bottom: -1px;
//       left: 0;
//       width: 100%;
//       height: 2px;
//       background-color: ${(props) => props.theme.brand.primary};
//     }
//   }
// `;
const Message = styled.div`
  width: 100%;
  padding: 0.75rem 0;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #82869e;
`;
const CenteredWrapper = styled.div`
  padding: 2rem;
  text-align: center;
  margin: 0;
`;
const NotificationPage: React.FunctionComponent = () => {
  const {
    notifications,
    promotions,
    checkpoint,
    loading,
    getNotifications,
    handleNotificationClicked,
    status,
  } = useNotification();
  const router = useRouter();
  const promoList = promotions.map((promotion: any) => (
    <MiniNotificationItem
      key={promotion.id}
      title={promotion.label}
      message={promotion.subLabel}
      isRead={true}
      onClick={() => {
        if (promotion.url) {
          router.push(promotion.url);
        }
      }}
      avatar={promotion.imageUrl}
    />
  ));
  const notiList = notifications.map((notification: Noti) => {
    return (
      <MiniNotificationItem
        key={notification.id}
        title={notification.title}
        message={notification.message}
        isRead={notification.is_read}
        onClick={() => {
          handleNotificationClicked(notification);
          if (notification.deepLink) {
            router.push(notification.deepLink);
          } else if (notification.order) {
            router.push(
              {
                pathname: `/account/orders/[orderId]`,
                query: {
                  orderId: notification.order.orderId,
                },
              },
              {
                pathname: `/account/orders/${notification.order.orderId}`,
              },
            );
          }
        }}
        time={notification.created_at}
        avatar={
          !notification.order
            ? notification.image_url
            : notification.order.imageUrl
        }
      />
    );
  });
  return (
    <Loading isLoading={loading}>
      <AccountLayout>
        <h5>{t('Thông báo của bạn')}</h5>
        <Card>
          {/* TODO: bug/UX4BUYER-2904 */}
          {/* <StyledTabs> */}
          {/* <StyledTab name={t('Tất cả')} index={0} title={t('Tất cả')} center> */}
          <div>
            {status === PageStatus.EMPTY && !loading ? (
              <CenteredWrapper>
                <EmptyState text={t('Bạn chưa có thông báo mới')} />
              </CenteredWrapper>
            ) : (
              <>
                {promoList}
                {notiList}
                {loading && <Message>{t('Đang tải thêm...')}</Message>}
                {!loading && !checkpoint && (
                  <Message>{t('Đã hết thông báo!')}</Message>
                )}
                {!loading && !!checkpoint && (
                  <Message>
                    <Button
                      variant="primary"
                      outline
                      size="sm"
                      onClick={() => getNotifications(checkpoint)}
                    >
                      {t('Tải thêm')}
                    </Button>
                  </Message>
                )}
              </>
            )}
          </div>
          {/* TODO: bug/UX4BUYER-2904 */}
          {/* </StyledTab> */}
          {/* <StyledTab
              name={t('Đơn hàng')}
              index={1}
              title={t('Đơn hàng')}
              center
            >
              <div>
                {!notifications.length ? (
                  <CenteredWrapper>
                    <EmptyState text={t('Bạn chưa có thông báo mới')} />
                  </CenteredWrapper>
                ) : (
                  <>
                    {notiList}
                    {loading && <Message>{t('Đang tải thêm...')}</Message>}
                    {!loading && !checkpoint && (
                      <Message>{t('Đã hết thông báo!')}</Message>
                    )}
                    {!loading && !!checkpoint && (
                      <Message>
                        <Button
                          variant="primary"
                          outline
                          size="sm"
                          onClick={() => getNotifications(checkpoint)}
                        >
                          {t('Tải thêm')}
                        </Button>
                      </Message>
                    )}
                  </>
                )}
              </div>
            </StyledTab>
            <StyledTab
              name={t('Khuyến mãi')}
              index={2}
              title={t('Khuyến mãi')}
              center
            >
              <div>
                {!promotions?.length ? (
                  <CenteredWrapper>
                    <EmptyState text={t('Bạn chưa có thông báo mới')} />
                  </CenteredWrapper>
                ) : (
                  promoList
                )}
              </div>
            </StyledTab> */}
          {/* </StyledTabs> */}
        </Card>
      </AccountLayout>
    </Loading>
  );
};
export default NotificationPage;
